import Main from '@/views/main'

export default [
    {
      path: "/chat",
      name: "chat",
      component: Main,
      // component: () => import('@/views/im/layout/chatRoute.vue'),
      meta: {
        icon: 'md-chatboxes',
        title: '聊天'
      },
      children: [
        {
          path: "main",
          name: "chatMain",
          meta: {
            icon: 'md-chatboxes',
            title: '聊天'
          },
          component: () => import('@/views/im/layout/chatRoute.vue'),
        },
      ]
    },
    {
      path: "/store",
      name: "store",
      component: Main,
      meta: {
        icon: 'md-appstore',
        title: '店铺'
      },
      children: [
        {
          path: "store_page",
          name: "storePage",
          meta: {
            icon: 'md-appstore',
            title: '店铺'
          },
          component: () => import('@/views/store/storeBox.vue'),
        },
      ]
    },
    {
      path: "/customer",
      name: "customer",
      component: Main,
      meta: {
        icon: 'md-contact',
        title: '客户'
      },
      children: [
        {
          path: "buyer_page",
          name: "buyerPage",
          meta: {
            icon: 'md-contact',
            title: '买家列表'
          },
          component: () => import('@/views/customer/buyerBox.vue'),
        },
        {
          path: "buyermodel_page",
          name: "buyerModelPage",
          meta: {
            icon: 'md-notifications',
            title: '买家模型'
          },
          component: () => import('@/views/customer/buyerModel.vue'),
        },
      ]
    },
    // {
    //   path: "/saleser",
    //   name: "saleser",
    //   component: Main,
    //   meta: {
    //     icon: 'md-contacts',
    //     title: '售后'
    //   },
    //   children: [
    //     {
    //       path: "saleser_page",
    //       name: "saleserPage",
    //       meta: {
    //         icon: 'md-contacts',
    //         title: '售后'
    //       },
    //       component: () => import('@/views/saleser/saleService.vue'),
    //     },
    //   ]
    // },
    {
      path: "/setting",
      name: "setting",
      component: Main,
      meta: {
        icon: 'md-settings',
        title: '设置'
      },
      children: [
        {
          path: "setting_page",
          name: "settingPage",
          meta: {
            icon: 'md-settings',
            title: '设置'
          },
          component: () => import('@/views/setting/setting_page.vue'),
        },
      ]
    },
    // {
    //   path: "/knowledge",
    //   name: "knowledge",
    //   component: Main,
    //   meta: {
    //     icon: 'md-bookmarks',
    //     title: '知识'
    //   },
    //   children: [
    //     {
    //       path: "knowledge_page",
    //       name: "knowledgePage",
    //       meta: {
    //         icon: 'md-bookmarks',
    //         title: '知识'
    //       },
    //       component: () => import('@/views/knowledge/knowledge_page.vue'),
    //     },
    //   ]
    // },
    {
      path: "/",
      name: "login-page",
      meta: {
        hideInMenu: true
      },
      component: require("@/views/login.vue").default
    }
  ];
